export default {"src":"/_next/static/image/public/images/download_app_hand_mobile_reverse_large.1086be1455c8fea18dfe5efc3bc1264c.svg","height":380,"width":289};